module.exports = __webpack_public_path__ + "img/mobile-38.62f9375d.png";